import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { ENDPOINTS } from "../../js/api/_config";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router";
import DataTable from "react-data-table-component";
import Header from "../common/header/Header";
import Icons from "../common/icons/icons";
import useToken from "../login/use-token";
import AutoColorChangingSVG from "./auto-color-changing-svg";
import {
  customStyles,
  customStylesTrialStatus,
} from "../common/styling/constants";
import SecondaryButton from "../common/buttons/SecondaryButton";
import PrimaryButton from "../common/buttons/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import SearchableDropdown from "./searchable-dropdown";
import { Toast } from "../common/toast/toast";
import PdfExport from "../trials/export-pdf";
import ExcelExport from "../trials/export-excel";
import StatusPatientChange from "./status-change-patient";
import {
  convertTimeToLocation,
  formatPhoneNumber,
} from "../common/constant/constant";
import { getTrailsName } from "../../reducer/slices/trial/get-trial-name-slice";
import SearchField from "./SearchField";
import { IconSortyBy } from "../../assets/icons/icon-sortby-arrow";
import {
  allStatusKeyValues,
  createStatusObjects,
  getInitials,
  getKeyOrValue,
  getStatusID,
  transcateText,
} from "./constant";
import { fetchTrialCount } from "../../js/api/trial-status";

import useMediaQuery from "../common/custom-hooks/use-media-query";
import { IconSortyByDisabled } from "../../assets/icons/icon-sortby-arrow-disabled";
import { CustomPagination } from "../common/custom-pagination/custom-pagination";
import { GridCallIcon } from "../../assets/icons/grid-call-icon";
import ringing_Audio from "../../assets/audio/ringtone.mp3";
import {
  removeCallData,
  setCallData,
} from "../../reducer/slices/twilio-calls/call-slice";
import StatusNoDD from "./status-no-dd";
import ScheduleModal from "../common/eclin-pro-modal/schedule-modal";
import EclinProSyncBadge from "../common/eclin-pro-sync-bradge/eclin-pro-sync-badge-trials-status";
import ExcelCsvExport from "./export-excel-csv";
let ringingAudio = new Audio(ringing_Audio);

const TrialStatuses = () => {
  const isCallInProgress = useSelector((state) => state.call.callData);

  const { key } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  let navigate = useNavigate();

  const dropdownRefs = useRef({});
  const dropdownRefExport = useRef({});
  const buttonRef = useRef(null);
  const divRef = useRef(null);

  const isBigDesktop = useMediaQuery("(min-width: 1537px)");

  const [wfList, setWfList] = useState([]);

  const lastPatient =
    wfList && wfList.length > 0 ? wfList[wfList.length - 1].patientID : "";
  const secondLastPatient =
    wfList && wfList.length > 3 ? wfList[wfList.length - 2].patientID : "";

  const [statusObj, setStatusObj] = useState();

  const [getMainAllData, setGetMainAllData] = useState([]);
  const [allStatus, setAllStatus] = useState([]);
  const [statusCount, setStatusCount] = useState([]);
  const [initialStatuses, setInitialStatuses] = useState();
  const location = useLocation();
  const { trialData } = location.state || {};
  const id = searchParams.get("trial_id");
  const [selectedStatus, setSelectedStatus] = useState(key);
  const [statusHover, setStatusHover] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isAssign, setIsAssign] = useState(false);
  const [isReroute, setIsReroute] = useState(false);
  const [toasts, setToasts] = useState([]);
  const [currRow, setCurrRow] = useState({});
  const { getToken } = useToken();
  const trailData = useSelector((state) => state.trails_name.data);
  const trailList = useSelector((state) => state.trails.data);
  const token = getToken();
  const dispatch = useDispatch();
  const recruiterData = useSelector((state) => state.recruiter_list.data);
  const [selectedRecruiter, setSelectedRecruiter] = useState("");
  const [selectedRecruiterId, setSelectedRecruiterId] = useState("");
  const [trailsName, setTrailsName] = useState();
  const [selectedTrailsNameId, setSelectedTrailsNameId] = useState();
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [searchStatus, setSearchStatus] = useState();
  const [position, setPosition] = useState();
  const [loader, setLoader] = useState(false);
  const [sortOrder, setSortOrder] = useState("desc");
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [scheduleModalProps, setScheduleModalProps] = useState({});
  const [isTrialLinkWithEclinPro, setIsTrialLinkWithEclinPro] = useState(false);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const searchParam = searchParams.get("search");
  const [search, setSearch] = useState(searchParam);

  const [showClose, setShowClose] = useState(false);
  const [isMiniScreen, setIsMiniScreen] = useState(false);
  const [status, setStatus] = useState("Calling");
  const user = useSelector((state) => state.user);
  const [getAllTStatus, setGetAllTStatus] = useState([]);

  const [rerouteReason, setrerouteReason] = useState("");
  const [error, setErrors] = useState({});
  const [rerouteReasonList, setRerouteReasonList] = useState([
    { id: 1, reason: "Not Interested" },
    { id: 2, reason: "Wrong Number" },
    { id: 3, reason: "No Response" },
    { id: 4, reason: "Other" },
  ]);

  const [_patientList, _setPatientList] = useState({
    trialID: searchParams.get("trialID"),
    status_id: searchParams.get("status_id"),
    status: searchParams.get("status"),
    Filters: searchParams.get("Filters"),
    Columns: searchParams.get("Columns"),
    trial_name: searchParams.get("trial_name"),
    trial_id: searchParams.get("trial_id"),
    sorting: searchParams.get("sorting") || sortOrder,
    search: searchParams.get("search"),
    data: [],
    totalCount: 0,
    Page: searchParams.get("Page") ? parseInt(searchParams.get("Page")) - 1 : 0,
    PageSize: searchParams.get("PageSize") || 10,
    refreshKey: true,
    isDisable: true,
  });
  const notify_unread_count = useSelector((state) => state.notify_unread_count);
  const { counts } = notify_unread_count || {};

  const handlePageChange = (page) => {
    _setPatientList({ ..._patientList, Page: page });
  };

  const handlePerPageChange = (perPage) => {
    _setPatientList({ ..._patientList, PageSize: perPage, Page: 0 });
  };

  const refreshPatientGrid = () => {
    _setPatientList({ ..._patientList, refreshKey: !_patientList.refreshKey });
  };

  const handleCall = async (data) => {
    if (!data.phoneNumber) {
      setStatus("Please enter a phone number");
      return;
    }
    dispatch(
      setCallData({
        params: {
          To: data.phoneNumber,
          PatientID: data.patientID,
          PatientTrialJuncID: data.patientTrialJuncID,
          UserID: user.userProfile.userID,
        },
        trialInfo: data,
        call: true,
        route: `/conversations/${data.patientTrialJuncID}`,
      })
    );
  };

  useEffect(() => {
    if (status === "Ringing") {
      ringingAudio.play().catch((err) => {
        console.warn("Ringtone play failed:", err);
      });
    } else {
      ringingAudio.pause();
      ringingAudio.currentTime = 0;
    }

    if (["Call ended", "No Answer"].includes(status)) {
      setTimeout(() => {
        setIsMiniScreen(false);
        dispatch(removeCallData());
        setStatus("");
      }, 2500);
    }
  }, [status]);

  const toggleDropdown = (e, row) => {
    setIsOpen(row.patientID === isOpen ? "" : row.patientID);
    setCurrRow(row);
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen !== null &&
        dropdownRefs.current[isOpen] &&
        !dropdownRefs.current[isOpen].contains(event.target)
      ) {
        setIsOpen(null);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isOpen]);

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };
  useEffect(() => {
    dispatch(getTrailsName({ token }));
  }, []);

  const fetchData = async () => {
    try {
      const {
        Page,
        PageSize,
        Sorts,
        trial_id,
        status_id,
        status,
        Filters,
        Columns,
        sorting,
        search,
      } = _patientList;

      const queryParams = {
        Page: Page + 1,
        PageSize,
        Sorts: sorting === "desc" ? "-MessageAt" : "MessageAt",
        trialID: trial_id,
        ...(search && { searchTerm: search }),
        ...(status_id && { statusID: status_id }),
        ...(Filters && { Filters }),
        ...(Columns && { Columns }),
      };

      _setPatientList({ ..._patientList, isDisable: true });

      const normalizedStatus = status?.toLowerCase();
      const apiEndpoint =
        {
          queued: ENDPOINTS.TRIALS.TRIAL_STATUS_QUEUED_WITH_QUERY,
          skipped: ENDPOINTS.TRIALS.TRIAL_STATUS_SKIPPED_WITH_QUERY,
        }[normalizedStatus] || ENDPOINTS.TRIALS.TRIAL_STATUS_WITH_QUERY;

      await axios
        .get(apiEndpoint, { params: queryParams })
        .then((res) => {
          setLoader(false);
          _setPatientList({
            ..._patientList,
            data: res.data.data.items,
            totalCount: res.data.data.count,
            isDisable: false,
          });
        })
        .catch((error) => {
          setLoader(false);
          _setPatientList({ ..._patientList, isDisable: false });
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getAllTrialStatus = async () => {
    const response = await axios
      .get(ENDPOINTS.TRIALS.GET_ALL_TRIAL_STATUS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setGetAllTStatus(res.data.data.items);
      });
  };

  useEffect(() => {
    getAllTrialStatus();
  }, []);

  useEffect(() => {
    fetchTrialCount(
      id,
      setStatusCount,
      (val) => {
        setAllStatus(val);
        setInitialStatuses(val);
      },
      token
    );
  }, []);

  const closePopup = () => {
    setIsModal(false);
    setIsAssign(false);
  };

  const onAssignClick = (row) => {
    setCurrRow(row);
    setIsModal(true);
    setIsAssign(true);
    setIsReroute(false);
  };

  const onDeleteClick = (row) => {
    setCurrRow(row);
    setIsModal(true);
    setIsAssign(false);
    setIsReroute(false);
  };

  const onRerouteClick = (row) => {
    setCurrRow(row);
    setIsModal(true);
    setIsReroute(true);
    setIsAssign(false);
    setTrailsName();
    setErrors({});
    setrerouteReason("");
    setSelectedTrailsNameId();
  };

  function convertTimestampInitialsOutreach(input) {
    const date = new Date(input);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  }

  function convertDateLastContracted(isoDateString) {
    const dateObj = new Date(isoDateString);

    // Extract date, month, and year
    const day = dateObj.getDate().toString().padStart(2, "0");
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
    const year = dateObj.getFullYear();

    // Extract hours and minutes
    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");

    // Determine AM/PM and adjust hours
    const amPm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format, 0 becomes 12

    // Format the final string
    return `${month}-${day}-${year} ${hours}:${minutes} ${amPm}`;
  }

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.style.setProperty(
        "border",
        "1px solid #245cea",
        "important"
      );
    }
  }, []);

  useEffect(() => {
    if (trailList && trailList.length > 0) {
      const get_trial = trailList.find(
        (trial) => trial.trialID.toString() === id
      );
      if (get_trial && get_trial.isTrialLinkWithEclinPro) {
        setIsTrialLinkWithEclinPro(true);
      }
    }
  }, [trailList, id]);

  const workflowColumnsList = [
    {
      name: "",
      selector: (row) =>
        row.statusName === "Queued" || row.statusName === "Skipped" ? (
          <div className="text-center w-[40px]">-</div>
        ) : (
          <div className="text-center w-[40px] flex ">
            {row.isUnread ? (
              <div className="flex items-center mr-[10px]">
                <div className="rounded-full w-[5px] h-[5px] bg-[#245CEA]"></div>
              </div>
            ) : (
              <div className="flex items-center mr-[10px]">
                <div className="rounded-full w-[5px] h-[5px]"></div>
              </div>
            )}
            <button
              onClick={() => {
                onChatClick(row.patientTrialJuncID, row);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                viewBox="0 0 20 22"
                fill="none"
              >
                <path
                  d="M10 8.23486L6 8.23486C5.58579 8.23486 5.25 7.89908 5.25 7.48486C5.25 7.07065 5.58579 6.73486 6 6.73486L10 6.73486C10.4142 6.73486 10.75 7.07065 10.75 7.48486C10.75 7.89908 10.4142 8.23486 10 8.23486Z"
                  fill="#245CEA"
                />
                <path
                  d="M5.25 11.4849C5.25 11.0707 5.58579 10.7349 6 10.7349H14C14.4142 10.7349 14.75 11.0707 14.75 11.4849C14.75 11.8991 14.4142 12.2349 14 12.2349H6C5.58579 12.2349 5.25 11.8991 5.25 11.4849Z"
                  fill="#245CEA"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.96644 0.734863H11.0336C12.4053 0.734859 13.4807 0.734855 14.3451 0.805475C15.2252 0.877386 15.9523 1.02624 16.6104 1.36158C17.6924 1.91285 18.572 2.79249 19.1233 3.87442C19.4586 4.53255 19.6075 5.25966 19.6794 6.1398C19.75 7.00414 19.75 8.07957 19.75 9.45128V12.2081C19.75 12.4645 19.75 12.6207 19.7436 12.7568C19.6033 15.7187 17.2338 18.0882 14.2719 18.2284C14.1358 18.2349 13.9639 18.2349 13.6788 18.2349H13.6504L13.5751 18.235C12.7079 18.2405 11.8632 18.5112 11.1543 19.0108L11.1051 19.0457L8.49441 20.9105C6.9899 21.9852 5.01288 20.4332 5.69954 18.7166C5.79183 18.4858 5.62191 18.2349 5.37341 18.2349H4.77166C2.27441 18.2349 0.25 16.2104 0.25 13.7132L0.25 9.4513C0.249995 8.07958 0.249992 7.00415 0.320612 6.1398C0.392522 5.25966 0.541379 4.53255 0.876713 3.87442C1.42798 2.79249 2.30762 1.91285 3.38955 1.36158C4.04769 1.02624 4.77479 0.877386 5.65494 0.805475C6.51929 0.734855 7.59472 0.734859 8.96644 0.734863ZM5.77708 2.30049C4.9897 2.36483 4.48197 2.48845 4.07054 2.69809C3.27085 3.10555 2.62068 3.75572 2.21322 4.5554C2.00359 4.96683 1.87996 5.47457 1.81563 6.26195C1.75058 7.05808 1.75 8.07236 1.75 9.48486V13.7132C1.75 15.382 3.10284 16.7349 4.77166 16.7349H5.37341C6.68311 16.7349 7.57867 18.0576 7.09226 19.2737C6.96197 19.5994 7.33709 19.8938 7.62255 19.6899L10.2333 17.8251L10.2902 17.7846C11.2493 17.1088 12.3922 16.7425 13.5655 16.735L13.6504 16.7349C13.9721 16.7349 14.1053 16.7346 14.201 16.7301C16.3902 16.6265 18.1416 14.8751 18.2452 12.6858C18.2498 12.5899 18.25 12.4719 18.25 12.1837V9.48486C18.25 8.07236 18.2494 7.05808 18.1844 6.26195C18.12 5.47457 17.9964 4.96683 17.7868 4.5554C17.3793 3.75571 16.7291 3.10555 15.9295 2.69809C15.518 2.48845 15.0103 2.36483 14.2229 2.30049C13.4268 2.23545 12.4125 2.23486 11 2.23486H9C7.58749 2.23486 6.57322 2.23545 5.77708 2.30049Z"
                  fill="#245CEA"
                />
              </svg>
            </button>
          </div>
        ),
      width: "60px",
    },
    {
      name: "",
      selector: (row) =>
        row.statusName === "Queued" || row.statusName === "Skipped" ? (
          <div className="text-center w-[40px]">-</div>
        ) : (
          <div className="text-center w-[40px]">
            <button
              disabled={isCallInProgress || row?.isCallInProgress}
              className={isCallInProgress || row?.isCallInProgress ? `cursor-not-allowed` : ``}
              onClick={() => onCallClick(row.patientTrialJuncID, row)}
            >
              <GridCallIcon />
            </button>
          </div>
        ),
      width: "60px",
    },
    {
      name: "Name",
      selector: (row) => (
        <div className="flex items-center">
          <p className="pl-1 whitespace-nowrap overflow-hidden text-ellipsis">
            <span className="block font-mont text-[14px] whitespace-nowrap overflow-hidden text-ellipsis">
              {row.patientName}
            </span>
          </p>
          {(row?.isEclinProSync || row?.eclinProSyncStatus == "failed" )? (
            <EclinProSyncBadge
              isSynced={row?.isEclinProSync}
              isSyncedStatus={row?.eclinProSyncStatus}
              eclinProSyncResult={row?.eclinProSyncResult}
              sendPatientName={row?.patientName}
            />
          ) : null}
          {row?.docuSignStatus === "recipient-completed" && (
            <>
              &nbsp;&nbsp;&nbsp;
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.62006 3.30203C10.5905 0.232657 15.4095 0.232657 16.3799 3.30203C16.9005 4.94853 18.7745 5.92516 20.6145 5.50885C24.0445 4.73277 26.454 8.49989 23.9944 10.7932C22.675 12.0234 22.675 13.9766 23.9944 15.2068C26.454 17.5001 24.0445 21.2672 20.6145 20.4912C18.7745 20.0748 16.9005 21.0515 16.3799 22.698C15.4095 25.7673 10.5905 25.7673 9.62006 22.698C9.0995 21.0515 7.22549 20.0748 5.38552 20.4912C1.95548 21.2672 -0.454034 17.5001 2.00558 15.2068C3.32499 13.9766 3.32499 12.0234 2.00558 10.7932C-0.454033 8.49989 1.95548 4.73277 5.38552 5.50885C7.22549 5.92516 9.0995 4.94853 9.62006 3.30203Z"
                  fill="#16C47F"
                />
                <path
                  d="M17.7552 9.78078L13.6377 14.2408C12.7912 15.1577 12.368 15.6161 11.8112 15.6161C11.2544 15.6161 10.8312 15.1577 9.98468 14.2408L8.2448 12.3562M5.38552 5.50885C7.22549 5.92516 9.0995 4.94853 9.62006 3.30203C10.5905 0.232657 15.4095 0.232657 16.3799 3.30203C16.9005 4.94853 18.7745 5.92516 20.6145 5.50885C24.0445 4.73277 26.454 8.49989 23.9944 10.7932C22.675 12.0234 22.675 13.9766 23.9944 15.2068C26.454 17.5001 24.0445 21.2672 20.6145 20.4912C18.7745 20.0748 16.9005 21.0515 16.3799 22.698C15.4095 25.7673 10.5905 25.7673 9.62006 22.698C9.0995 21.0515 7.22549 20.0748 5.38552 20.4912C1.95548 21.2672 -0.454034 17.5001 2.00558 15.2068C3.32499 13.9766 3.32499 12.0234 2.00558 10.7932C-0.454033 8.49989 1.95548 4.73277 5.38552 5.50885Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </>
          )}
        </div>
      ),
      width: isBigDesktop ? "auto" : "140px",
    },
    {
      name: "Contact",
      selector: (row) => formatPhoneNumber(row.phoneNumber),
      width: isBigDesktop ? "auto" : "140px",
    },
    {
      name: "Initial Outreach",
      selector: (row) =>
        row.statusName === "Queued" || row.statusName === "Skipped"
          ? row.initialOutreach
            ? convertTimestampInitialsOutreach(row.initialOutreach)
            : "-"
          : convertTimestampInitialsOutreach(row.initialOutreach),
      minWidth: isBigDesktop ? "auto" : "180px",
    },
    {
      name: "Last Contacted",
      selector: (row) =>
        row.statusName === "Queued" || row.statusName === "Skipped"
          ? row.lastContacted
            ? convertTimestampInitialsOutreach(row.lastContacted)
            : "-"
          : convertDateLastContracted(convertTimeToLocation(row.lastContacted)),
      width: isBigDesktop ? "auto" : "160px",
    },
    {
      name: "Status",
      selector: (row) =>
        row.statusName === "Queued" ? (
          <StatusNoDD name="Queued" />
        ) : row.statusName === "Skipped" ? (
          <StatusNoDD name="Skipped" />
        ) : (
          <StatusPatientChange
            options={getAllTStatus}
            row={row}
            initialValue={
              <span className="flex gap-2 items-center align-content">
                {row.statusName}
                <svg
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.33301 1.6665L5.99967 6.33317L10.6663 1.6665"
                    stroke="#1A1A1B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            }
            disabledAlreadySelected={row.statusName}
            onSelect={(selectedOption) => {
              if (
                row.statusName === "Scheduled Screen" &&
                selectedOption.statusName === "Scheduled Screen"
              ) {
                return;
              }
              if (
                selectedOption.statusName === "Scheduled Screen_1" &&
                isTrialLinkWithEclinPro
              ) {
                setScheduleModalOpen(true);
                setScheduleModalProps({
                  patientTrialJuncID: row.patientTrialJuncID,
                  statusName: selectedOption.statusName,
                  selectedOption: selectedOption.normalizedStatus,
                  trialID: id,
                  patientName: row.patientName,
                });
              } else {
                handleDropdownSelect(
                  id,
                  row.patientTrialJuncID,
                  selectedOption.statusName,
                  selectedOption.normalizedStatus
                );
              }
            }}
          />
        ),
      width: "250px",
    },
    {
      name: "Assigned To",
      selector: (row) =>
        row.assignedRecruiter ? (
          row.assignedRecruiter
        ) : (
          <div className="text-center w-full">-</div>
        ),
      cell: (row) =>
        row.assignedRecruiter ? (
          <div className="flex items-center">
            <p>
              <span className="recruiter-intials">
                {getInitials(row.assignedRecruiter)}
              </span>
            </p>
            <p className="pl-1">
              <span className="block">
                {transcateText(
                  row.firstName ? row.firstName : "" + row.assignedRecruiter,
                  15
                )}{" "}
              </span>
            </p>
          </div>
        ) : (
          <div className="text-center w-full">-</div>
        ),
      width: isBigDesktop ? "auto" : "200px",
    },
    {
      name: "",
      conditionalCellStyles: [
        {
          when: () => true,
          style: {
            position: "sticky",
            right: 0,
            backgroundColor: "white",
            justifyContent: "space-around",
            borderLeft: "1px solid #C8D6E6",
            borderBottom: "1px solid #C8D6E6",
          },
        },
      ],
      selector: (row) =>
        row.statusName === "Queued" || row.statusName === "Skipped" ? (
          ""
        ) : (
          <div
            className="relative"
            ref={(el) => (dropdownRefs.current[row.patientID] = el)}
          >
            {/* Button to toggle the dropdown */}
            <button onClick={(e) => toggleDropdown(e, row)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#373737"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                  stroke="#373737"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                  stroke="#373737"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        ),
      width: "70px",
    },
  ];

  const handleDropdownSelect = async (
    id,
    rowpatientid,
    statusName,
    normalizedStatus,
    scheduleData = {}
  ) => {
    try {
      setScheduleLoading(true);
      const { startDate, endDate, locationId, notes, patientName } =
        scheduleData;

      const params = {
        patientTrialJuncId: rowpatientid,
        statusName: normalizedStatus,
      };

      if (startDate) params.startDateTime = startDate;
      if (endDate) params.endDateTime = endDate;
      if (locationId) params.locationId = locationId;
      if (notes) params.note = notes;

      const response = await axios
        .put(`${ENDPOINTS.TRIALS.CHANGE_PATIENT_STATUS}`, null, {
          params: params,
        })
        .then(() => {
          setScheduleModalOpen(false);
          setScheduleLoading(false);
        });

      // if (normalizedStatus === "ScheduledScreen" && isTrialLinkWithEclinPro) {
      //   addToast(
      //     `${patientName} successfully synced with eClin Pro`,
      //     "success"
      //   );
      // }
      refreshPatientGrid();
    } catch (error) {
      console.error("Error fetching data:", error);
      if (
        error &&
        error.response &&
        error.response.data &&
        typeof error.response.data.message === "string"
      ) {
        addToast(error.response.data.message, "error");
      }
      setScheduleLoading(false);
    }
  };

  const onChatClick = (id, data) => {
    navigate(`/conversations/${id}`);
  };

  const onCallClick = (id, data) => {
    handleCall(data);

    setIsMiniScreen(false);
  };

  const handleStatusClick = (status) => {
    setSelectedStatus(status);
    const val = getKeyOrValue(statusObj, status);
    const getStatus = getKeyOrValue(statusObj, val);
    setStatusHover(false);
    const statusID = getStatusID(getStatus, getAllTStatus) || "";
    _setPatientList({
      ..._patientList,
      status_id: statusID,
      status: status,
      Page: 0,
      search: "",
    });
    setSearch("");
  };

  const deleteTrialStatus = async (
    trialID,
    patientID,
    patientTrialJuncID,
    token
  ) => {
    const url = `${ENDPOINTS.TRIALS.DELETE_TRIAL_STATUS}`;

    const requestBody = {
      trialID: trialID,
      patientID: patientID,
      patientTrialJuncID: patientTrialJuncID,
    };

    try {
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: requestBody,
      });

      if (response.status === 200) {
        closePopup();
        setIsOpen(false);
        refreshPatientGrid();
        addToast("The patient has been deleted successfully.", "success");
        return response.data;
      } else {
        addToast("Failed to delete patient", "error");
      }
    } catch (error) {
      addToast("Error deleting patient:", "error");
    }
  };

  const reRouteTrialStatus = async (
    trialID,
    patientID,
    patientTrialJuncID,
    token
  ) => {
    const url = `${ENDPOINTS.TRIALS.REROUTE}`;

    // if(!rerouteReason){
    //   setErrors({ rerouteReason: "Reason is required" });
    //   return;
    // }

    const requestBody = {
      trialID: selectedTrailsNameId,
      patientTrialJuncID: patientTrialJuncID,
      patientID: patientID,
      reRouteReason: rerouteReason,
    };

    try {
      const response = await axios.put(url, requestBody, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        closePopup();
        setIsOpen(false);
        refreshPatientGrid();
        addToast("Trial status rerouted successfully", "success");
        return response.data;
      } else {
        addToast("Failed to rerouting trial status", "error");
      }
    } catch (error) {
      const message = error?.response?.data?.message;

      if (message) {
        addToast(error.response.data.message, "error");
        return;
      }

      const error_res = error.response?.data?.errors || {};
      if (error_res) {
        const firstKey = Object.keys(error_res)[0];
        const message = error_res[firstKey][0];
        addToast(message, "error");
        return;
      }

      addToast("Error in rerouting trial status:", "error");
    }
  };

  async function assignPatientToRecruiter(
    trialID,
    patientID,
    recruiterID,
    token
  ) {
    const url = `${ENDPOINTS.TRIALS.ASSIGN_RECRUITER}`;

    const payload = {
      trialID: trialID,
      patientID: patientID,
      recruiterID: recruiterID,
    };

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to assign patient to recruiter");
      }
      const data = await response.json();
      addToast(`Recruiter assigned to ${currRow.patientName}`, "success");
      closePopup();
      setSelectedRecruiter();
      setSelectedRecruiterId();
      refreshPatientGrid();
      setIsOpen(false);
      return data;
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const handleSort = async (sortType) => {
    setSortOrder(sortType);
    _setPatientList({ ..._patientList, sorting: sortType });
  };

  const handleToggleDropdown = () => {
    setDropdownVisible((prevState) => !prevState);
  };

  const onSearchClick = () => {
    _setPatientList({
      ..._patientList,
      search: search,
      Page: 0,
    });
    setShowClose(true);
    setIsOpen(false);
  };

  useEffect(() => {
    if (!search && searchParam) {
      _setPatientList({
        ..._patientList,
        search: null,
        Page: 0,
      });
    }
  }, [search]);

  const onCloseClick = () => {
    setWfList([...getMainAllData]);
    setSearch("");
    setShowClose(false);
  };

  const handleSelectChange = (e) => {
    const selectedName = e.target.value;
    setTrailsName(selectedName);
    const selectedTrailNames = trailData.find(
      (tz) => tz.trialName === selectedName
    );

    setSelectedTrailsNameId(selectedTrailNames.trialID);
  };

  const handleReasonSelectChange = (e) => {
    const selectedName = e.target.value;
    setrerouteReason(selectedName);
  };

  const handleReasonChange = (e) => {
    if (e.target.value.length <= 500) {
      setrerouteReason(e.target.value);
    }
  };

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefExport.current &&
        !dropdownRefExport.current.contains(event.target)
      ) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside2);
    return () => {
      document.removeEventListener("click", handleClickOutside2);
    };
  }, [isDropdownVisible]);

  const goBackToTrials = () => {
    navigate("/trials");
  };

  useEffect(() => {
    const handleScroll = () => {
      closePopupOnScroll();
    };

    window.addEventListener("scroll", handleScroll, true); // use capture to catch all scrolls

    return () => window.removeEventListener("scroll", handleScroll, true);
  }, []);

  const closePopupOnScroll = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    setIsOpen(false);
  }, [isModal, isAssign, isReroute]);

  useEffect(() => {
    const status = getKeyOrValue(statusObj, key);
    if (status != selectedStatus) {
      setSelectedStatus(status);
    }
  }, [key]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData();

      const params = new URLSearchParams();
      params.set("Page", parseInt(_patientList.Page) + 1);
      params.set("PageSize", _patientList.PageSize);
      params.set("sorting", _patientList.sorting);

      if (_patientList.Filters) params.set("filter", _patientList.Filters);
      if (_patientList.status_id)
        params.set("status_id", _patientList.status_id);
      if (_patientList.status) params.set("status", _patientList.status);
      if (_patientList.Columns) params.set("Columns", _patientList.Columns);
      if (_patientList.trial_name)
        params.set("trial_name", _patientList.trial_name);
      if (_patientList.trial_id) params.set("trial_id", _patientList.trial_id);
      if (_patientList.search) params.set("search", _patientList.search);

      navigate(
        `/trial-statuses/${
          allStatusKeyValues[_patientList.status || "All"]
        }?${params.toString()}`,
        { replace: true }
      );
    }, 500); // ⏳ 500ms debounce duration

    return () => clearTimeout(handler); // cleanup
  }, [
    _patientList.Page,
    _patientList.PageSize,
    _patientList.sorting,
    _patientList.Filters,
    _patientList.trialID,
    _patientList.status_id,
    _patientList.status,
    _patientList.Columns,
    _patientList.trial_name,
    _patientList.refreshKey,
    _patientList.trial_id,
    _patientList.search,
    counts,
  ]);

  const handleDownload = async (statusID) => {
    try {
      // Base API URL with required trialID
      let url = `https://dev.api.eclinrecruit.ai/api/trial/get-export-patient-trial-status?trialID=${id}`;

      // Append statusID only if it's provided
      if (statusID) {
        url += `&statusID=${statusID}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "text/plain",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "patient-trial-status.csv"; // or .xlsx
      document.body.appendChild(link);

      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <div>
      <Header
        headertitle={
          (trialData && trialData.trialName) || _patientList.trial_name
        }
        goBackToTrials={goBackToTrials}
        backbutton={true}
        showClose={showClose}
        isSearch={true}
        search={search}
        setSearch={setSearch}
        onSearchClick={onSearchClick}
        onCloseClick={onCloseClick}
      />
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}

      {loader ? (
        <div className="spinnerwrapper">
          <div className="spinner"></div>
        </div>
      ) : (
        <>
          <div className="flex justify-between" ref={divRef}>
            <div className="LeftColumn w-[320px] border-[#C8D6E6] border-r">
              <SearchField
                search={searchStatus}
                setSearch={setSearchStatus}
                allStatus={allStatus}
                setAllStatus={setAllStatus}
                initialStatuses={initialStatuses}
                setInitialStatuses={setInitialStatuses}
              />
              <ul className="w-[280px]">
                {allStatus && allStatus.length
                  ? allStatus.map((status, i) => (
                      <li
                        key={i}
                        onClick={() => handleStatusClick(status)}
                        className="flex relative cursor-pointer"
                        onMouseEnter={() => {
                          setStatusHover(status);
                        }}
                        onMouseLeave={() => {
                          setStatusHover();
                        }}
                      >
                        <div
                          className={`flex my-auto pl-4 py-2 ${
                            selectedStatus === status || statusHover === status
                              ? "text-blue-500 bg-[#221F930D] w-full h-full"
                              : "text-black-500"
                          }`}
                        >
                          <div className="my-auto">
                            <Icons
                              status={status}
                              color={
                                selectedStatus === status ||
                                statusHover === status
                                  ? "blue"
                                  : "black"
                              }
                            />
                          </div>
                          <div className="flex w-auto">
                            <span className="ml-4">{status}</span>
                            <span className="absolute right-2">
                              <AutoColorChangingSVG
                                selected={
                                  selectedStatus === status ||
                                  statusHover === status
                                }
                                label={status}
                                count={statusCount[status]}
                              />
                            </span>
                          </div>
                        </div>
                      </li>
                    ))
                  : ""}
              </ul>
            </div>

            <div className="RightColumn w-full mt overflow-auto">
              <div className="flex justify-between border-b border-[#C8D6E6]">
                <div className="flex p-5">
                  <div className="flex pl-5">
                    <div className="flex">
                      <div className="flex justify-between items-center w-full relative title_color">
                        <div className="m-auto">Sort by:</div>
                        <select
                          disabled={key == "queued" || key == "skipped"}
                          onChange={(e) =>
                            handleSort(e.target.value, false, true)
                          }
                          value={sortOrder}
                          className="focus:outline-none font-[500] appearance-none pl-[10px] pr-[20px]"
                        >
                          <option
                            value="desc"
                            className="p-[20px] hover:bg-gray-200 cursor-pointer text-gray-700"
                          >
                            Newest
                          </option>
                          <option
                            value="asc"
                            className="p-[20px] hover:bg-gray-200 cursor-pointer text-gray-700"
                          >
                            Oldest
                          </option>
                        </select>
                        <span className="transform -translate-y-1/2 pointer-events-none absolute mt-6 right-[-10px]">
                          {key == "queued" || key == "skipped" ? (
                            <IconSortyByDisabled />
                          ) : (
                            <IconSortyBy />
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex gap-5">
                  <CustomPagination
                    rowsPerPage={_patientList.PageSize}
                    rowCount={_patientList.totalCount}
                    onChangePage={handlePageChange}
                    currentPage={_patientList.Page}
                    handlePerPageChange={handlePerPageChange}
                    isDisable={_patientList.isDisable}
                  />
                  <div className="relative p-5" ref={dropdownRefExport}>
                    <button
                      onClick={handleToggleDropdown}
                      className="inline-flex items-center px-4 py-2 bg-white border border-[#245CEA] rounded-md text-sm font-medium text-gray-800 shadow-sm hover:bg-gray-100 focus:outline-none focus:none focus:none focus:none"
                    >
                      <svg
                        className="mr-2"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                          stroke="#1B2A3D"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.333 5.3335L7.99967 2.00016L4.66634 5.3335"
                          stroke="#1B2A3D"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8 2L8 10"
                          stroke="#1B2A3D"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Export
                      <span className="ml-2 text-xs text-gray-500">
                        <svg
                          width="12"
                          height="8"
                          viewBox="0 0 12 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.33301 1.6665L5.99967 6.33317L10.6663 1.6665"
                            stroke="#1A1A1B"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </button>

                    {isDropdownVisible && (
                      <div
                        className="p-dd flex flex-col text-left border-solid border bg-white border-[#D1D7DC] w-[125px] rounded-lg absolute top-[40px!important] left-[20px!important] mt-5"
                        onClick={handleToggleDropdown}
                      >
                        <PdfExport
                          name="PDF"
                          icon={true}
                          class="bg-red"
                          tableData={_patientList.data || []} // need to check
                          columns={workflowColumnsList}
                          fileName="Trials Status"
                          classes={
                            "py-2.5 px-5 me-2 mb-0 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-none border border-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-0 text-left"
                          }
                        />
                        <ExcelCsvExport
                          trialId={id}
                          token={token}
                          name="Excel"
                          containerClass={"py-[1px]"}
                           classes={
                            "py-2.5 px-5 me-2 mb-0 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-none border border-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-0 text-left w-full"
                          }
                          statusID={_patientList.status_id} // optional
                        />
                        <ExcelCsvExport
                          trialId={id}
                          token={token}
                          containerClass={"py-[1px]"}
                           name="CSV"
                           type="CSV"
                           classes={
                            "py-2.5 px-5 me-2 mb-0 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-none border border-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-0 text-left w-full mb-3"
                          }
                          statusID={_patientList.status_id} // optional
                        />
                        
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-5 mx-5 tbl-trial-statuses">
                <DataTable
                  columns={workflowColumnsList}
                  data={_patientList.data || []}
                  sortIcon={<span>?</span>}
                  customStyles={customStylesTrialStatus}
                />
              </div>
            </div>
          </div>
          {isModal && (
            <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
              {isAssign ? (
                <div className="bg-white rounded-lg shadow-lg max-w-[480px] min-h-[226px] w-full p-6 relative">
                  <div>
                    <div>
                      <div className="flex flex-row mt-2 text-sm items-center">
                        <span className="asign-popup-bg item-center bg-[#6F6EDE1A]">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="24"
                            viewBox="0 0 18 24"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M8.99994 2.88867C7.09763 2.88867 5.5555 4.4308 5.5555 6.33312C5.5555 8.23543 7.09763 9.77756 8.99994 9.77756C10.9023 9.77756 12.4444 8.23543 12.4444 6.33312C12.4444 4.4308 10.9023 2.88867 8.99994 2.88867ZM3.5555 6.33312C3.5555 3.32623 5.99306 0.888672 8.99994 0.888672C12.0068 0.888672 14.4444 3.32623 14.4444 6.33312C14.4444 9.34 12.0068 11.7776 8.99994 11.7776C5.99306 11.7776 3.5555 9.34 3.5555 6.33312ZM0.222168 18.5553C0.222168 15.5485 2.65973 13.1109 5.66661 13.1109H12.3333C15.3402 13.1109 17.7777 15.5485 17.7777 18.5553C17.7777 21.5622 15.3402 23.9998 12.3333 23.9998H5.66661C2.65973 23.9998 0.222168 21.5622 0.222168 18.5553ZM5.66661 15.1109C3.7643 15.1109 2.22217 16.653 2.22217 18.5553C2.22217 20.4577 3.7643 21.9998 5.66661 21.9998H12.3333C14.2356 21.9998 15.7777 20.4577 15.7777 18.5553C15.7777 16.653 14.2356 15.1109 12.3333 15.1109H5.66661Z"
                              fill="#6F6EDE"
                            />
                          </svg>
                        </span>
                        <span className="font-mont text-[16px] m-4">
                          Assign <b>{currRow.patientName}</b> to{" "}
                          <b>Recruiter</b>
                        </span>
                      </div>
                    </div>
                    <div>
                      <div className="flex flex-row text-sm items-center">
                        <span className="asign-popup-bg"></span>
                        <div className="font-mont text-[16px] m-4 relative w-full">
                          <SearchableDropdown
                            selectedRecruiterId={selectedRecruiterId}
                            setSelectedRecruiterId={setSelectedRecruiterId}
                            recruiterData={recruiterData.items || []}
                            selectedRecruiter={selectedRecruiter}
                            setSelectedRecruiter={setSelectedRecruiter}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-row justify-end gap-5 mt-5 pr-4">
                      <PrimaryButton
                        label="Assign"
                        onClick={() => {
                          assignPatientToRecruiter(
                            currRow.trialID,
                            currRow.patientID,
                            selectedRecruiterId,
                            token
                          );
                        }}
                        classes="px-[19px] py-[8px]"
                      />
                      <SecondaryButton
                        onClick={closePopup}
                        label="Cancel"
                        classes={"px-5 py-3"}
                      />
                    </div>
                  </div>
                </div>
              ) : isReroute ? (
                <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
                  <div>
                    <div>
                      <label for="timezone" class="block form_label_color">
                        Select a Trials to Reroute {currRow.patientName}
                      </label>
                      <div className="flex  mt-2 text-sm items-center relative">
                        <select
                          id="trailsName"
                          name="trailsName"
                          value={trailsName}
                          className=" border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                          onChange={handleSelectChange}
                        >
                          <option value={""} selected>
                            Select Trial
                          </option>
                          {trailData &&
                            trailData.length > 0 &&
                            trailData
                              ?.filter(
                                (tz) => tz.trialName !== _patientList.trial_name
                              )
                              .map((tz) => (
                                <option key={tz.trialID} value={tz.trialName}>
                                  {tz.trialName}
                                </option>
                              ))}
                        </select>
                        {/* {errors.trailsName && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{errors.trailsName}</p>} */}
                        <span className="absolute right-4 top-[25px] transform -translate-y-1/2 pointer-events-none">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                              stroke="#245CEA"
                              strokeWidth="2"
                              stroke-miterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>

                    {/* <div>
                      <label for="timezone" class="block form_label_color pt-2">
                        Select a Reason
                      </label>
                      <div className="flex  mt-2 text-sm items-center relative">
                        <select
                          id="rerouteReason"
                          name="rerouteReason"
                          className=" border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                          onChange={handleReasonSelectChange}
                        >
                          <option value={""} selected>
                            Select Reason
                          </option>
                          {rerouteReasonList && rerouteReasonList.length > 0 && rerouteReasonList
                            .map((r) => (
                              <option key={r.id} value={r.reason}>
                                {r.reason}
                              </option>
                            ))}
                        </select>
                        <span className="absolute right-4 top-[25px] transform -translate-y-1/2 pointer-events-none">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                              stroke="#245CEA"
                              strokeWidth="2"
                              stroke-miterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div> */}

                    <textarea
                      className="field_bg border_color border text-base rounded-lg block w-full p-2.5 mt-5 h-40"
                      value={rerouteReason}
                      onChange={(e) => handleReasonChange(e)}
                      placeholder="Type your Reason here..."
                    ></textarea>

                    <div className="flex justify-between items-center mt-2">
                      <div>
                        {error.rerouteReason && (
                          <p className="text-[#F95454] font-mont text-[14px] font-[500]">
                            {error.rerouteReason}
                          </p>
                        )}
                      </div>

                      <div className="text-sm text-gray-600">
                        {rerouteReason.length} / 500
                      </div>
                    </div>

                    <div className="flex flex-row justify-end gap-5 mt-5">
                      <button
                        className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500"
                        onClick={() => {
                          reRouteTrialStatus(
                            currRow.trialID,
                            currRow.patientID,
                            currRow.patientTrialJuncID,
                            token
                          );
                        }}
                      >
                        Reroute
                      </button>
                      <SecondaryButton
                        onClick={closePopup}
                        label="Cancel"
                        classes={"px-5 py-3"}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
                  <div>
                    <div>
                      <div className="flex flex-row mt-2 text-sm items-center">
                        <span className="delete-popup-bg item-center">
                          <svg
                            width="18"
                            height="22"
                            viewBox="0 0 18 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.5172 11.7795L16.26 11.8829L15.5172 11.7795ZM15.2549 13.6645L15.9977 13.7679L15.2549 13.6645ZM2.74514 13.6645L3.48798 13.5611L2.74514 13.6645ZM2.4828 11.7795L1.73996 11.8829L2.4828 11.7795ZM6.18365 20.7368L5.89206 21.4278L6.18365 20.7368ZM3.47508 17.5603L4.17907 17.3017L3.47508 17.5603ZM14.5249 17.5603L15.2289 17.819V17.819L14.5249 17.5603ZM11.8164 20.7368L11.5248 20.0458H11.5248L11.8164 20.7368ZM2.74664 7.92906C2.70746 7.5167 2.34142 7.21418 1.92906 7.25336C1.5167 7.29254 1.21418 7.65858 1.25336 8.07094L2.74664 7.92906ZM16.7466 8.07094C16.7858 7.65858 16.4833 7.29254 16.0709 7.25336C15.6586 7.21418 15.2925 7.5167 15.2534 7.92906L16.7466 8.07094ZM17 6.75C17.4142 6.75 17.75 6.41421 17.75 6C17.75 5.58579 17.4142 5.25 17 5.25V6.75ZM1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75V5.25ZM6.25 17C6.25 17.4142 6.58579 17.75 7 17.75C7.41421 17.75 7.75 17.4142 7.75 17H6.25ZM7.75 9C7.75 8.58579 7.41421 8.25 7 8.25C6.58579 8.25 6.25 8.58579 6.25 9H7.75ZM10.25 17C10.25 17.4142 10.5858 17.75 11 17.75C11.4142 17.75 11.75 17.4142 11.75 17H10.25ZM11.75 9C11.75 8.58579 11.4142 8.25 11 8.25C10.5858 8.25 10.25 8.58579 10.25 9H11.75ZM13 6V6.75H13.75V6H13ZM5 6H4.25V6.75H5V6ZM14.7744 11.6761L14.512 13.5611L15.9977 13.7679L16.26 11.8829L14.7744 11.6761ZM3.48798 13.5611L3.22564 11.6761L1.73996 11.8829L2.0023 13.7679L3.48798 13.5611ZM9 20.25C7.47083 20.25 6.92544 20.2358 6.47524 20.0458L5.89206 21.4278C6.68914 21.7642 7.60558 21.75 9 21.75V20.25ZM2.0023 13.7679C2.282 15.7777 2.43406 16.9017 2.77109 17.819L4.17907 17.3017C3.91156 16.5736 3.77851 15.6488 3.48798 13.5611L2.0023 13.7679ZM6.47524 20.0458C5.55279 19.6566 4.69496 18.7058 4.17907 17.3017L2.77109 17.819C3.3857 19.4918 4.48205 20.8328 5.89206 21.4278L6.47524 20.0458ZM14.512 13.5611C14.2215 15.6488 14.0884 16.5736 13.8209 17.3017L15.2289 17.819C15.5659 16.9017 15.718 15.7777 15.9977 13.7679L14.512 13.5611ZM9 21.75C10.3944 21.75 11.3109 21.7642 12.1079 21.4278L11.5248 20.0458C11.0746 20.2358 10.5292 20.25 9 20.25V21.75ZM13.8209 17.3017C13.305 18.7058 12.4472 19.6566 11.5248 20.0458L12.1079 21.4278C13.5179 20.8328 14.6143 19.4918 15.2289 17.819L13.8209 17.3017ZM3.22564 11.6761C3.00352 10.08 2.83766 8.88703 2.74664 7.92906L1.25336 8.07094C1.34819 9.06897 1.51961 10.2995 1.73996 11.8829L3.22564 11.6761ZM16.26 11.8829C16.4804 10.2995 16.6518 9.06896 16.7466 8.07094L15.2534 7.92906C15.1623 8.88702 14.9965 10.08 14.7744 11.6761L16.26 11.8829ZM17 5.25H1V6.75H17V5.25ZM7.75 17V9H6.25V17H7.75ZM11.75 17V9H10.25V17H11.75ZM12.25 5V6H13.75V5H12.25ZM13 5.25H5V6.75H13V5.25ZM5.75 6V5H4.25V6H5.75ZM9 1.75C10.7949 1.75 12.25 3.20507 12.25 5H13.75C13.75 2.37665 11.6234 0.25 9 0.25V1.75ZM9 0.25C6.37665 0.25 4.25 2.37665 4.25 5H5.75C5.75 3.20507 7.20507 1.75 9 1.75V0.25Z"
                              fill="#DC3545"
                            />
                          </svg>
                        </span>
                        <span className="font-mont text-[16px] m-4">
                          Are you sure want to delete{" "}
                          <b>{currRow.patientName}</b>?
                        </span>
                      </div>
                    </div>

                    <div className="flex flex-row justify-end gap-5 mt-5">
                      <button
                        className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 red_btn"
                        onClick={() => {
                          deleteTrialStatus(
                            currRow.trialID,
                            currRow.patientID,
                            currRow.patientTrialJuncID,
                            token
                          );
                        }}
                      >
                        Delete
                      </button>
                      <SecondaryButton
                        onClick={closePopup}
                        label="Cancel"
                        classes={"px-5 py-3"}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}

      {isOpen && (
        <>
          <div
            className={`fixed ${
              (lastPatient === currRow.patientID && wfList.length > 6) ||
              (secondLastPatient === currRow.patientID && wfList.length > 6)
                ? "bottom-[100px] right-0"
                : "right-0"
            } w-40 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 z-10 py-3 max-w-[156px]`}
            style={{
              left:
                position.left + 100 > window.innerWidth
                  ? "auto"
                  : position.left + 100,
              right: position.left + 100 > window.innerWidth ? "30px" : "auto",
              top:
                position.top + 120 > window.innerHeight
                  ? "auto"
                  : position.top - 110,
              bottom:
                position.top + 70 > window.innerHeight
                  ? "30px"
                  : position.top + 120 > window.innerHeight
                  ? "120px"
                  : position.top + 120 > window.innerHeight
                  ? "30px"
                  : "auto",
            }}
          >
            <button
              onClick={(e) => {
                onRerouteClick(currRow);
                const rect = e.currentTarget.getBoundingClientRect();
                setPosition({
                  top: rect.bottom + window.scrollY,
                  left: rect.left + window.scrollX,
                });
              }}
              className="w-full px-4 py-2 text-left text-[#0F1114] hover:bg-[#221F931A] flex font-mont text-[12px] font[500]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="15"
                viewBox="0 0 11 15"
                fill="none"
              >
                <path
                  d="M3.28571 5.21401C4.54808 5.21401 5.57143 4.19066 5.57143 2.92829C5.57143 1.66593 4.54808 0.642578 3.28571 0.642578C2.02335 0.642578 1 1.66593 1 2.92829C1 4.19066 2.02335 5.21401 3.28571 5.21401Z"
                  stroke="#1A1A1B"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.25725 14.3566C5.99489 14.3566 4.97154 13.3332 4.97154 12.0709C4.97154 10.8085 5.99489 9.78516 7.25725 9.78516C8.51962 9.78516 9.54297 10.8085 9.54297 12.0709C9.54297 13.3332 8.51962 14.3566 7.25725 14.3566Z"
                  stroke="#1A1A1B"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.14258 2.92773H9.54258"
                  stroke="#1A1A1B"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 7.5L9.57143 7.5"
                  stroke="#1A1A1B"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.40039 12.0703H1.00039"
                  stroke="#1A1A1B"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.57129 7.5L9.57129 2.92857"
                  stroke="#1A1A1B"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 12.0703L1 7.49888"
                  stroke="#1A1A1B"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="ml-4">Reroute</span>
            </button>
            <button
              onClick={() => {
                onAssignClick(currRow);
              }}
              className="w-full px-4 py-2 text-left text-[#0F1114] hover:bg-[#221F931A] flex font-mont text-[12px] font[500]"
            >
              <svg
                width="12"
                height="15"
                viewBox="0 0 12 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.06634 3.50065C8.06634 4.64204 7.14106 5.56732 5.99967 5.56732V6.76732C7.8038 6.76732 9.26634 5.30478 9.26634 3.50065H8.06634ZM5.99967 5.56732C4.85829 5.56732 3.93301 4.64204 3.93301 3.50065H2.73301C2.73301 5.30478 4.19554 6.76732 5.99967 6.76732V5.56732ZM3.93301 3.50065C3.93301 2.35926 4.85829 1.43398 5.99967 1.43398V0.233984C4.19554 0.233984 2.73301 1.69652 2.73301 3.50065H3.93301ZM5.99967 1.43398C7.14106 1.43398 8.06634 2.35926 8.06634 3.50065H9.26634C9.26634 1.69652 7.8038 0.233984 5.99967 0.233984V1.43398ZM3.99967 8.76732H7.99967V7.56732H3.99967V8.76732ZM7.99967 12.9007H3.99967V14.1007H7.99967V12.9007ZM3.99967 12.9007C2.85829 12.9007 1.93301 11.9754 1.93301 10.834H0.733008C0.733008 12.6381 2.19554 14.1007 3.99967 14.1007V12.9007ZM10.0663 10.834C10.0663 11.9754 9.14106 12.9007 7.99967 12.9007V14.1007C9.8038 14.1007 11.2663 12.6381 11.2663 10.834H10.0663ZM7.99967 8.76732C9.14106 8.76732 10.0663 9.6926 10.0663 10.834H11.2663C11.2663 9.02985 9.8038 7.56732 7.99967 7.56732V8.76732ZM3.99967 7.56732C2.19554 7.56732 0.733008 9.02985 0.733008 10.834H1.93301C1.93301 9.6926 2.85829 8.76732 3.99967 8.76732V7.56732Z"
                  fill="#1A1A1B"
                />
              </svg>{" "}
              <span className="ml-4">Assign</span>
            </button>
            <button
              onClick={() => onDeleteClick(currRow)}
              className="w-full px-4 py-2 text-left text-[#DC3545] hover:bg-[#221F931A] flex font-mont text-[12px] font[500]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="15"
                viewBox="0 0 12 15"
                fill="none"
              >
                <path
                  d="M10.3451 8.02031L10.8404 8.08923L10.3451 8.02031ZM10.1702 9.277L10.6655 9.34592L10.1702 9.277ZM1.83042 9.277L2.32564 9.20808L1.83042 9.277ZM1.65553 8.02032L1.1603 8.08924L1.65553 8.02032ZM4.12276 13.9919L3.92836 14.4525H3.92836L4.12276 13.9919ZM2.31705 11.8742L2.78637 11.7018L2.31705 11.8742ZM9.6836 11.8742L10.1529 12.0466L9.6836 11.8742ZM7.87789 13.9919L7.6835 13.5312L7.87789 13.9919ZM1.83142 5.45336C1.8053 5.17845 1.56127 4.97677 1.28637 5.00289C1.01146 5.02901 0.809781 5.27304 0.835901 5.54794L1.83142 5.45336ZM11.1648 5.54795C11.1909 5.27304 10.9892 5.02901 10.7143 5.00289C10.4394 4.97677 10.1954 5.17845 10.1692 5.45336L11.1648 5.54795ZM11.3337 4.66732C11.6098 4.66732 11.8337 4.44346 11.8337 4.16732C11.8337 3.89118 11.6098 3.66732 11.3337 3.66732V4.66732ZM0.666992 3.66732C0.39085 3.66732 0.166992 3.89118 0.166992 4.16732C0.166992 4.44346 0.39085 4.66732 0.666992 4.66732V3.66732ZM4.16699 11.5007C4.16699 11.7768 4.39085 12.0007 4.66699 12.0007C4.94313 12.0007 5.16699 11.7768 5.16699 11.5007H4.16699ZM5.16699 6.16732C5.16699 5.89118 4.94313 5.66732 4.66699 5.66732C4.39085 5.66732 4.16699 5.89118 4.16699 6.16732H5.16699ZM6.83366 11.5007C6.83366 11.7768 7.05752 12.0007 7.33366 12.0007C7.6098 12.0007 7.83366 11.7768 7.83366 11.5007H6.83366ZM7.83366 6.16732C7.83366 5.89118 7.6098 5.66732 7.33366 5.66732C7.05752 5.66732 6.83366 5.89118 6.83366 6.16732H7.83366ZM8.66699 4.16732V4.66732H9.16699V4.16732H8.66699ZM3.33366 4.16732H2.83366V4.66732H3.33366V4.16732ZM9.8499 7.95139L9.67501 9.20808L10.6655 9.34592L10.8404 8.08923L9.8499 7.95139ZM2.32564 9.20808L2.15075 7.9514L1.1603 8.08924L1.33519 9.34592L2.32564 9.20808ZM6.00033 13.6673C4.98088 13.6673 4.61728 13.6579 4.31715 13.5312L3.92836 14.4525C4.45975 14.6768 5.07071 14.6673 6.00033 14.6673V13.6673ZM1.33519 9.34592C1.52166 10.6858 1.62303 11.4351 1.84772 12.0466L2.78637 11.7018C2.60803 11.2164 2.51933 10.5998 2.32564 9.20808L1.33519 9.34592ZM4.31715 13.5312C3.70219 13.2717 3.1303 12.6379 2.78637 11.7018L1.84772 12.0466C2.25746 13.1619 2.98836 14.0559 3.92836 14.4525L4.31715 13.5312ZM9.67501 9.20808C9.48132 10.5998 9.39262 11.2164 9.21428 11.7018L10.1529 12.0466C10.3776 11.4351 10.479 10.6858 10.6655 9.34592L9.67501 9.20808ZM6.00033 14.6673C6.92994 14.6673 7.5409 14.6768 8.07229 14.4525L7.6835 13.5312C7.38337 13.6579 7.01977 13.6673 6.00033 13.6673V14.6673ZM9.21428 11.7018C8.87035 12.6379 8.29846 13.2717 7.6835 13.5312L8.07229 14.4525C9.01229 14.0559 9.74319 13.1619 10.1529 12.0466L9.21428 11.7018ZM2.15075 7.9514C2.00267 6.88734 1.8921 6.092 1.83142 5.45336L0.835901 5.54794C0.899118 6.2133 1.0134 7.03368 1.1603 8.08924L2.15075 7.9514ZM10.8404 8.08923C10.9873 7.03368 11.1015 6.21329 11.1648 5.54795L10.1692 5.45336C10.1086 6.092 9.99798 6.88734 9.8499 7.95139L10.8404 8.08923ZM11.3337 3.66732H0.666992V4.66732H11.3337V3.66732ZM5.16699 11.5007V6.16732H4.16699V11.5007H5.16699ZM7.83366 11.5007V6.16732H6.83366V11.5007H7.83366ZM8.16699 3.50065V4.16732H9.16699V3.50065H8.16699ZM8.66699 3.66732H3.33366V4.66732H8.66699V3.66732ZM3.83366 4.16732V3.50065H2.83366V4.16732H3.83366ZM6.00033 1.33398C7.19694 1.33398 8.16699 2.30403 8.16699 3.50065H9.16699C9.16699 1.75175 7.74923 0.333984 6.00033 0.333984V1.33398ZM6.00033 0.333984C4.25142 0.333984 2.83366 1.75175 2.83366 3.50065H3.83366C3.83366 2.30403 4.80371 1.33398 6.00033 1.33398V0.333984Z"
                  fill="#DC3545"
                />
              </svg>
              <span className="ml-4">Delete</span>
            </button>
          </div>
        </>
      )}

      {scheduleModalOpen && (
        <ScheduleModal
          open={scheduleModalOpen}
          setOpen={setScheduleModalOpen}
          scheduleModalProps={scheduleModalProps}
          loading={scheduleLoading}
          setLoading={setScheduleLoading}
          onSchedule={(data) => {
            handleDropdownSelect(
              data.id,
              data.patientTrialJuncID,
              data.statusName,
              data.selectedOption,
              data
            );
          }}
        />
      )}
    </div>
  );
};

export default TrialStatuses;
